
const get_status_order  = (status_key)=> { 
    const status_list = {'wait_pay':'error','do':'info','work':'warning','close':'sucess'}
    return status_list[status_key]
    }
const get_status_name_order  = (status_key)=> {
    const status_list = {'wait_pay':'Ожидает оплаты','do':'Отправляем в работу','work':'В работе','close':'Выполнен'}
    return status_list[status_key]
}
const formatDate = (dateString) => {
  const options = { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' };
  const date = new Date(dateString);
  // Объединяем дату и время в одну строку, удаляя часовой пояс
  const formattedDate = date.toLocaleDateString('ru-RU', options);
  return `${formattedDate}`;
}
const parseDate = (dateString) => {
    const parsedDate = new Date(dateString); 
    if (!isNaN(parsedDate)) { 
        const day = parsedDate.getDate().toString().padStart(2, '0');
        const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
        const year = parsedDate.getFullYear();  
        return `${year}-${month}-${day}`;
    } else {
      return ''
    }
  };
const get_status_task  = (status_key)=> { 
    const status_list = {'do':'warning','work':'warning','wait_cheack':'warning','wait_cheack2':'warning','wait_pay':'info','delete':'warning','close':'info'}
    return status_list[status_key]
    }
const get_status_name_task  = (status_key)=> {
    const status_list = {'do':'Создан','work':'Выполняем','wait_cheack':'Проверяем','wait_cheack2':'Проверяем','wait_pay':'Выполнен','delete':'Отменён','close':'Выполнен'}
    return status_list[status_key]
}
const sendMetrics = (type = null, name = null) => {
    if(type && name) window.ym(90149575, type, name);
  }
const getStorageValue = (key, defaultValue)=> {
    try {
      // getting stored value
      const saved = localStorage.getItem(key); 
      if (saved !== null && saved !== undefined && saved !== '') {
        
        const initial = JSON.parse(saved);
        return initial  ;
      }
      else
      { 
        return  defaultValue;
    
      }
    } catch (error) {
      console.error(`${key} ${error}`)
      return  defaultValue;
      
    }
}
const getStorageValueTime =(key, defaultValue,minute=60) => {
  try {
    const saved =  getStorageValue(key,defaultValue)
    const expirationTime = 60 * minute * 1000; // 1 hour in milliseconds
    if (saved !== null && saved !== undefined && saved !== '') 
    { 
      if (Date.now() - saved.timestamp < expirationTime) {
        if(saved.value !={}){ 
          return saved.value;
        }
      } 
    }
    return defaultValue 
  } catch (error) {
    console.error(`${key} ${error}`)
    return  defaultValue;
    
  }
}
const getParamFromURL = (paramName,defaultValue) => {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(paramName);     
  if(value) 
    return value
  return defaultValue
}
const setParamInURL = (paramName, paramValue) => {
  // Получаем текущий URL
  let url = window.location.href;

  // Создаем новый URLSearchParams объект на основе текущего URL
  let searchParams = new URLSearchParams(window.location.search);

  // Устанавливаем значение параметра в URLSearchParams
  searchParams.set(paramName, paramValue);

  // Получаем строку параметров
  let paramString = searchParams.toString();

  // Заменяем старую строку параметров на новую в URL
  url = url.split('?')[0] + '?' + paramString;

  // Обновляем URL в истории браузера без перезагрузки страницы
  window.history.pushState({ path: url }, '', url);
};
   
export {get_status_name_order,
        get_status_order,
        get_status_task,
        get_status_name_task,
        parseDate,
        sendMetrics,
        getStorageValue,
        getStorageValueTime,
        getParamFromURL,
        setParamInURL,
        formatDate}